module.exports = __webpack_public_path__ + "static/media/icn_kyc_doc_rejected.b69d245e.svg";